const transitionAuto = require("@alexspirgel/transition-auto");
const childrenLoaded = require("@alexspirgel/children-loaded");

class SiteWideHeader extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    await childrenLoaded(this);
    this.initialize();
  }

  initialize() {

    if (!this.initialized) {
      this.initialized = true;

      this.watchWPAdminBarHeight();
      this.watchFixedContainerHeight();
      this.watchFixedContainerTop();
      this.listenForMobileSubMenuToggleButtonClick();
      this.watchMobileMenuScroll();
			this.positionIndustriesMenu();

      if (this.mobileMenuToggleElement) {
        this.mobileMenuToggleElement.addEventListener("click", this.toggleMobileMenu);
      }

    }
  }

  get wpAdminBarSelector() {
    return "#wpadminbar";
  }

  get wpAdminBarElement() {
    return document.querySelector(this.wpAdminBarSelector);
  }

  get wpAdminBarHeight() {
    if (this.wpAdminBarElement) {
      return this.wpAdminBarElement.offsetHeight;
    } else {
      return 0;
    }
  }

  get wpAdminBarHeightFixedMinViewportWidth() {
    return 601;
  }

  get isWPAdminBarFixed() {
    const mediaQuery = window.matchMedia(`(min-width: ${this.wpAdminBarHeightFixedMinViewportWidth}px)`);
    if (mediaQuery.matches) {
      return true;
    } else {
      return false;
    }
  }

  updateWPAdminBarHeightCSSVariable() {
    this.style.setProperty("--wp-admin-bar-height", `${this.wpAdminBarHeight}px`);
    this.lastKnownWPAdminBarHeight = this.wpAdminBarHeight;
  }

  watchWPAdminBarHeight() {
    this.updateWPAdminBarHeightCSSVariable();
    const resizeObserver = new ResizeObserver(() => {
      if (this.wpAdminBarHeight !== this.lastKnownWPAdminBarHeight) {
        this.updateWPAdminBarHeightCSSVariable();
      }
    });
    resizeObserver.observe(this.fixedContainerElement);
  }

  get fixedContainerSelector() {
    return ".block-site-wide-header";
  }

  get fixedContainerElement() {
    return this; // this.querySelector(this.fixedContainerSelector);
  }

  get fixedContainerHeight() {
    if (this.fixedContainerElement) {
      return this.fixedContainerElement.offsetHeight;
    } else {
      return 0;
    }
  }

  updateFixedContainerHeightCSSVariable() {

		console.log (`fixed container height: ${this.fixedContainerHeight}px`);

    this.style.setProperty("--fixed-container-height", `${this.fixedContainerHeight}px`);
    document.body.style.setProperty("--fixed-container-height", `${this.fixedContainerHeight}px`);
    this.lastKnownFixedContainerHeight = this.fixedContainerHeight;
  }

  watchFixedContainerHeight() {
    this.updateFixedContainerHeightCSSVariable();
    const resizeObserver = new ResizeObserver(() => {
      if (this.fixedContainerHeight !== this.lastKnownFixedContainerHeight) {
        this.updateFixedContainerHeightCSSVariable();
      }
    });
    resizeObserver.observe(this.fixedContainerElement);
  }

  updateFixedContainerTopCSSVariable() {
    if (this.isWPAdminBarFixed) {
      if (this.lastKnownFixedContainerTop !== 0) {
        this.style.setProperty("--fixed-container-top", "0px");
        this.lastKnownFixedContainerTop = 0;
      }
    } else {
      let newFixedContainerTop = 0;
      if (window.scrollY < this.wpAdminBarHeight) {
        newFixedContainerTop = this.wpAdminBarHeight - window.scrollY;
      }
      if (this.lastKnownFixedContainerTop !== newFixedContainerTop) {
        this.style.setProperty("--fixed-container-top", `${newFixedContainerTop}px`);
        this.lastKnownFixedContainerTop = newFixedContainerTop;
      }
    }
  }

  watchFixedContainerTop() {
    this.updateFixedContainerTopCSSVariable();
    document.addEventListener("scroll", () => {
      this.updateFixedContainerTopCSSVariable();
    });
    window.addEventListener("resize", () => {
      this.updateFixedContainerTopCSSVariable();
    });
  }

  get mobileMenuToggleSelector() {
    return ".block-site-wide-header__mobile-menu-toggle";
  }

  get mobileMenuToggleElement() {
    return this.querySelector(this.mobileMenuToggleSelector);
  }

  get mobileMenuToggleClass() {
    return "mobile-menu-active";
  }

  preventBodyScroll() {
    document.body.style.overflow = "hidden";
  }

  allowBodyScroll() {
    document.body.style.overflow = "auto";
  }

  toggleMobileMenu = () => {
    if (this.mobileMenuToggleElement) {
      if (this.classList.contains(this.mobileMenuToggleClass)) {
        this.hideMobileMenu();
        this.allowBodyScroll();
      } else {
        this.showMobileMenu();
        this.preventBodyScroll();
      }
    } else {
      throw new Error(`Could not find mobile menu toggle element using selector: ${this.mobileMenuToggleSelector}.`);
    }
  };

  showMobileMenu = () => {
    this.classList.add(this.mobileMenuToggleClass);
  };

  hideMobileMenu = () => {
    this.classList.remove(this.mobileMenuToggleClass);
  };

  get mobileNavContainerSelector() {
    return ".block-site-wide-header__main-navigation-container";
  }

  get mobileNavContainerElement() {
    return this.querySelector(this.mobileNavContainerSelector);
  }

  watchMobileMenuScroll() {
    if (this.mobileNavContainerElement) {
      this.mobileNavContainerElement.addEventListener("scroll", this.mobileMenuScrollHandler);
    }
  }

  mobileMenuScrollHandler = () => {
    if (this.mobileNavContainerElement) {
      if (this.mobileNavContainerElement.scrollTop > 3) {
        this.mobileNavContainerElement.classList.add("is-scrolled");
      } else {
        this.mobileNavContainerElement.classList.remove("is-scrolled");
      }
    }
  };

  get mobileMenuItemWithSubMenuSelector() {
    return ".block-site-wide-header__main-menu > li.menu-item-has-children";
  }

  get mobileMenuItemWithSubMenuElements() {
    return this.querySelectorAll(this.mobileMenuItemWithSubMenuSelector);
  }

  listenForMobileSubMenuToggleButtonClick() {
    for (const mobileMenuItemWithSubMenuElement of this.mobileMenuItemWithSubMenuElements) {
      const toggleButton = mobileMenuItemWithSubMenuElement.querySelector(".block-site-wide-header__sub-menu-toggle");
      if (toggleButton) {
        toggleButton.addEventListener("click", this.mobileSubMenuToggleButtonClickHandler);
      }
    }
  }

  mobileSubMenuToggleButtonClickHandler = (event) => {
    const menuItemElement = event.target.closest(this.mobileMenuItemWithSubMenuSelector);
    if (menuItemElement) {
      this.toggleMobileSubMenu(menuItemElement);
    }
  };

  toggleMobileSubMenu(menuItemElement) {
    if (menuItemElement.classList.contains("open")) {
      this.closeMobileSubMenu(menuItemElement);
    } else {
      this.openMobileSubMenu(menuItemElement);
    }
  }

  openMobileSubMenu(menuItemElement) {
    menuItemElement.classList.add("open");
    const subMenuWrapperElement = menuItemElement.querySelector(".sub-menu-wrapper");
    transitionAuto({
      element: subMenuWrapperElement,
      property: "height",
      value: "auto",
    });
  }

  closeMobileSubMenu(menuItemElement) {
    menuItemElement.classList.remove("open");
    const subMenuWrapperElement = menuItemElement.querySelector(".sub-menu-wrapper");
    transitionAuto({
      element: subMenuWrapperElement,
      property: "height",
      value: "0px",
    });
  }

	positionIndustriesMenu() {

		const applyIndustriesMenuPosition = () => {
			const industriesSubMenu = document.querySelector('.sub-menu-wrapper-industries');
			const industriesMenuItem = document.querySelector('.menu-item-industries');
			const subMenuPadding = '1rem';

			if (industriesMenuItem) {
				const industriesMenuRect = industriesMenuItem.getBoundingClientRect();

				industriesSubMenu.style.setProperty('left', "calc(" + parseInt(industriesMenuRect.left).toString() + 'px' + ` - ${subMenuPadding})`);
			}
		}

		applyIndustriesMenuPosition();

		const resizeObserver = new ResizeObserver(() => {
			applyIndustriesMenuPosition();
		});
		resizeObserver.observe(this.fixedContainerElement);

	}
}

customElements.define("block-site-wide-header", SiteWideHeader, { extends: "header" });
